import { render } from "./ConfigMarcasParceiras.vue?vue&type=template&id=7008eda3&scoped=true&ts=true"
import script from "./ConfigMarcasParceiras.vue?vue&type=script&lang=ts"
export * from "./ConfigMarcasParceiras.vue?vue&type=script&lang=ts"

import "./ConfigMarcasParceiras.vue?vue&type=style&index=0&id=7008eda3&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7008eda3"]])

export default __exports__